const path = "/app/inventory";

export const inventoryRouteMeta = [
  {
    type: "redirect",
    key: "INVENTORY_OVERVIEW",
    from: path,
    to: `${path}/overview`,
    exact: true,
  },
  { 
    type: "route", 
    key: "INVENTORY_OVERVIEW", 
    path: `${path}/overview` 
  },
  {
    type: "inner-route",
    key: "INVENTORY_DEVICE_INFO",
    path: `${path}/devices/`,
  },
  {
    type: "route",
    key: "INVENTORY_DEVICES",
    path: `${path}/devices/*`,
    subScopes: [
      { key: "INVENTORY_DEVICES_OVERVIEW", path: `${path}/devices/overview/*` },
      { key: "INVENTORY_DEVICES_SYSTEM", path: `${path}/devices/system/*` },
      { key: "INVENTORY_DEVICES_SOFTWARE", path: `${path}/devices/software/*` },
      { key: "INVENTORY_DEVICES_HARDWARE", path: `${path}/devices/hardware/*` },
      { key: "INVENTORY_DEVICES_SECURITY", path: `${path}/devices/security/*` },
      { key: "INVENTORY_DEVICES_PATCHES", path: `${path}/devices/patches/*` },
      { key: "INVENTORY_DEVICES_VULNERABILITIES", path: `${path}/devices/vulnerabilities/*`},
      { key: "INVENTORY_DEVICES_LOCATION", path: `${path}/devices/location/*` },
      { key: "INVENTORY_DEVICES_CERTIFICATES", path: `${path}/devices/certificates/*` },
    ],
  },
  {
    type: "inner-route",
    key: "INVENTORY_SOFTWARE_INFO",
    path: `${path}/apps/`,
  },
  {
    type: "route",
    key: "INVENTORY_SOFTWARE",
    path: `${path}/apps/*`,
    subScopes: [
      { key: "INVENTORY_SOFTWARE_INFO", path: `${path}/apps/info` }
    ],
  },
  {
    type: "inner-route",
    key: "INVENTORY_HARDWARE_INFO",
    path: `${path}/hardware/`,
  },
  {
    type: "route",
    key: "INVENTORY_HARDWARE",
    path: `${path}/hardware/*`,
    subScopes: [
      { key: "INVENTORY_HARDWARE_INFO", path: `${path}/hardware/info` },
    ],
  },
  { 
    type: "route", 
    key: "GEO_LOCATION", 
    path: `${path}/deviceLocations` 
  },
  {
    type: "route",
    key: "SOFTWARE_LICENSE",
    path: `${path}/software-license/*`,
  },
  {
    type: "route",
    key: "APPLICATION_CONTROL",
    path: `${path}/application-control/*`,
  },
  {
    type: "route",
    key: "SOFTWARE_METERING",
    path: `${path}/software-metering/*`,
  },
  { 
    type: "route", 
    key: "SCAN_DEVICE", 
    path: `${path}/settings/scan-devices` 
  },
  {
    type: "route",
    key: "SCHEDULE_SCAN",
    path: `${path}/settings/schedule-scan/*`,
  },
  { 
    type: "route", 
    key: "SCAN_SETTINGS", 
    path: `${path}/settings/scan` 
  },
  { 
    type: "route", 
    key: "DEVICE_WARRANTY", 
    path: `${path}/settings/device-warranty` 
  },
  {
    type: "route",
    key: "SOFTWARE_CATEGORY",
    path: `${path}/settings/software-category/*`,
  },
  {
    type: "route",
    key: "GEO_LOCATION_SETTINGS",
    path: `${path}/settings/geo-location`,
  },
];